<template>
  <div>
    <v-app-bar
      height="60"
      style="border: none;"
      class="bg-header"
      clipped-left
      app
      flat>
      <v-app-bar-nav-icon
        v-if="isMobile"
        color="white"
        @click="onClickMobileMenu()" />
      <v-icon
        v-else
        color="white"
        @click="mini = !mini">
        {{ mini ? 'mdi-menu' : 'mdi-menu-open' }}
      </v-icon>
      <div
        class="d-flex pr-2 cs-pointer"
        @click="$router.push( { name:'AccountSuperAdmin' })">
        <div class="reactive">
          <v-avatar
            class="mx-3 "
            :class="{ 'backgound': mini }"
            size="36px">
            <v-img
              alt="Avatar"
              :src="userData?.imageUrl" />
          </v-avatar>
          <!-- <span class="notification absolute">5</span> -->
        </div>
        <v-list-item-content class="py-0 white--text card-user">
          <v-list-item-title class="header-user">
            {{ userData?.firstName }} {{ userData?.lastName }}
          </v-list-item-title>
          <v-list-item-subtitle>  {{ userData?.role === 'ADMIN' ? 'Admin' : 'Super admin' }} </v-list-item-subtitle>
        </v-list-item-content>
      </div>
      <HeaderTitle
        :imgicon="$route.meta.icon"
        :headername="$route.meta.name" />
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      color="menu"
      clipped
      app>
      <v-list
        :style="listHeight"
        class="overflow-y-auto overflow-x-hidden my-1 py-0"
        dense>
        <v-list-item-group
          v-for="(item, index) in menu"
          :key="`menu-${index}`"
          no-action
          mandatory>
          <v-list-group
            v-if="item.subMenu"
            :value="false"
            no-action>
            <template #activator>
              <v-list-item-icon
                v-if="item.icon">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title class="ml-2">
                {{ item.title }}
              </v-list-item-title>
            </template>
            <ListMenu
              v-for="(subMenu, i) in item.subMenu"
              :key="`${item.title}-${subMenu.title}-${i}`"
              :title="subMenu.title"
              :to="subMenu.to"
              :icon="subMenu.icon"
              icon-prepend
              is-submenu />
          </v-list-group>
          <ListMenu
            v-else
            :title="item.title"
            :to="item.to"
            :icon="item.icon"
            icon-prepend />
          <v-divider
            v-if="item.title === 'รายงาน' && userData?.role !== 'ADMIN'"
            class="my-2 mx-3 primary" />
        </v-list-item-group>
      </v-list>

      <template #append>
        <v-list-item :to="{ name: 'LogoutPage' }">
          <v-list-item-icon v-if="mini">
            <v-icon color="white">
              mdi-logout
            </v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            <v-btn
              class="btn-logout text-capitalize white--text"
              :block="!mini"
              :min-width="mini ? '' : 'auto'"
              :class="{ 'px-0': mini }"
              depressed>
              ออกจากระบบ
            </v-btn>
          </v-list-item-title>
        </v-list-item>
      </template>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { getRole } from '@/assets/js/auth'
import menu from '@/assets/json/menu/navigation.json'
import HeaderTitle from '@/components/HeaderTitle.vue'
import ListMenu from './ListMenu.vue'

export default {
  name: 'NavigationDrawer',
  components: {
    ListMenu,
    HeaderTitle
    // ButtonTootip
    // Search
  },
  data () {
    return {
      menu,
      menus: false,
      mini: false,
      drawer: true
    }
  },
  computed: {
    userData () {
      return this.$store.getters['User/user']
    },
    // route () {
    //   const findRoute = this.headerName.find((item) => item.routerName === this.$route.name)
    //   if (!findRoute) return ''
    //   return findRoute
    // },
    isMobile () {
      return this.$vuetify.breakpoint.width < 1024
    },
    listHeight () {
      if (this.isMobile) {
        return 'height: calc(100vh - 58px);'
      }
      return 'height: calc(100vh - 126px);'
    },
    menuShowForRole () {
      const role = getRole()

      return this.menu.filter((item) => {
        const hasRole = !item.roles || item.roles.includes(role)
        return hasRole
      })
    }
  },
  methods: {
    setDrawer (value) {
      this.drawer = value
    },
    goMyAccount () {
      this.$router.push({ name: 'MyAccount' })
    },
    onClickMobileMenu () {
      this.mini = false
      this.setDrawer(true)
    }
  }
}
</script>

<style lang="scss" scoped>
// ::-webkit-scrollbar {
//   background: var(--v-menu-base);
//   width: 2px;
// }
// ::-webkit-scrollbar-thumb {
//   background: #C1C1C1;
//   border-radius: 8px;
// }
::-webkit-scrollbar {
  background: transparent;
  width: 0px;
}
::v-deep(.v-list-item-group .v-list-item--active){
  background: linear-gradient(90deg, var(--v-menu-base) 0%, var(--v-primary-base) 100%);
  border-radius: 50px;
}
.user-profile{
  cursor: pointer;
}
.user-profile:hover{
  background: #aef0f8;
}
.border-linear{
border: 1px solid;
background: linear-gradient(90deg, #0E153A 0%, #219DAB 100%);
}

.notification{
color: white;
background-color: red;
font-size: 1px;
border-radius: 100%;
width: 15px;
height: 15px;
text-align: center;
left: 75px;
top: 10px;
}
.card-user{
  width: 150px;
}
.bg-header {
  background: linear-gradient(90deg, #0E153A 0%, #219DAB 100%);
}
.btn-logout{
background-color: #3E4461 !important;
border-radius: 50px;
}
::v-deep(.v-btn:not(.v-btn--round).v-size--default){
  min-width: 34px;
  text-align: center;
}
</style>
